import hooks from './shipment-reports.hooks';

export default (app) => {
  const service = app.service('api/shipment-reports');
  service.hooks(hooks);
};
